import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserRoleResource } from '@app/shared/resources/user-role.resource';
import { UserRole } from '@app/shared/models/user-role.interface';

@Injectable({
  providedIn: 'root'
})
export class UserRoleService {
  constructor(private userRoleResource: UserRoleResource) {}

  public getAllForBuilding(buildingId: number): Observable<UserRole[]> {
    return this.userRoleResource.getAllForBuilding(buildingId, 1, 1, false);
  }

  public updateUserRoles(buildingId: number, userRole: UserRole): Observable<{}> {
    return this.userRoleResource.updateUserRoles(buildingId, userRole);
  }

  public removeUserFromBuilding(buildingId: number, userId: number): Observable<{}> {
    return this.userRoleResource.removeUserFromBuilding(buildingId, userId);
  }
}
